import React from 'react'
import { Form, Grid, Modal, Button, Segment } from 'semantic-ui-react'
import RolloverRowProperty from './rowProperty'
import RolloverRowDebt from './rowDebt'
import RolloverRowOther from './rowOther'
import logo from 'img/logo.png'
import * as types from '../../consts'
import '../../style.css'

/* const months = [
  {'text': 'Optional', 'value': 'opt'},
  {'text': 'Jan', 'value': 'jan'},
  {'text': 'Feb', 'value': 'feb'},
  {'text': 'Mar', 'value': 'mar'},
  {'text': 'Apr', 'value': 'apr'},
  {'text': 'May', 'value': 'may'},
  {'text': 'Jun', 'value': 'jun'},
  {'text': 'Jul', 'value': 'jul'},
  {'text': 'Aug', 'value': 'aug'},
  {'text': 'Sep', 'value': 'sep'},
  {'text': 'Oct', 'value': 'oct'},
  {'text': 'Nov', 'value': 'nov'},
  {'text': 'Dec', 'value': 'dec'}
] */
class RolloverEvents extends React.Component {  
  renderType = (type) => {
    switch (type) {
      case types.stepProperty: return 'Property'
      case types.stepIncomes: return 'Income'
      case types.stepDebts: return 'Debt'
      case types.stepSavings: return 'Saving'
      case types.stepActivities: return 'Activity'
      case types.stepLifestyle: return 'Expense'
      default: return 'Unknown'
    }
  }
 
  onChange = (e, id) => {
    const { events } = this.props 
    const event = events.find(e => e.id === id)
    if (!event || !e) return null
    event[e.target.name] = e.target.value
    if (event.process !== 1) event.process = 1
    this.setState({event})
  }
 /*  onDelete = (id)=>{
    const { events } = this.props
    const event = events.find(e => e.id === id)
    event.process = event.process > -999 ? -999 : -1    
    this.setState({event})
  } */
  setNo = (id, value) => {
    const { events } = this.props
    const event = events.find(e => e.id === id)
    if (!!event ) {
      event.process = value
      this.setState({event})
    }
  }
  setYes = (id) => {
    const { events } = this.props
    const event = events.find(e => e.id === id)
    if (!!event ) {
      event.process = 1
      this.setState({event})
    }
  }
  renderHeader = (type, action) => {
    switch (type) {
      case 'property':
        if (action === 'end') {
          return (
            <Grid.Row verticalAlign="middle" color='grey' >
              <Grid.Column width={5}>Description</Grid.Column>
              <Grid.Column width={4}></Grid.Column>
              <Grid.Column width={4}>Action</Grid.Column> 
              <Grid.Column width={3}>Did This Happen</Grid.Column>
            </Grid.Row>
          ) 
        } 
        return (
          <Grid.Row verticalAlign="middle" color='grey'>
            <Grid.Column width={5}>Description</Grid.Column>
            <Grid.Column width={4}>Purchase Price</Grid.Column>
            <Grid.Column width={4}>Operating Costs</Grid.Column> 
            <Grid.Column width={3}>Will This Happen</Grid.Column>
          </Grid.Row>
        ) 
        case 'debt':
          if (action === 'end') {
            return (
              <Grid.Row verticalAlign="middle" color='grey'>
                <Grid.Column width={4}>Description</Grid.Column>
                <Grid.Column width={3}></Grid.Column>
                <Grid.Column width={4}></Grid.Column> 
                <Grid.Column width={2}>Action</Grid.Column>
                <Grid.Column width={3}>Did This Happen</Grid.Column>
              </Grid.Row>
            ) 
          } 
          return (
            <Grid.Row verticalAlign="middle" color='grey'>
              <Grid.Column width={4}>Description</Grid.Column>
              <Grid.Column width={3}>Amount</Grid.Column>
              <Grid.Column width={4}>Payment</Grid.Column>
              <Grid.Column width={2}>Rate</Grid.Column>
              <Grid.Column width={3}>Will This Happen</Grid.Column>
            </Grid.Row>
          )  
        case 'saving':
          if (action === 'end') {
            return (
              <Grid.Row verticalAlign="middle" color='grey'>
                <Grid.Column width={5}>Description</Grid.Column>
                <Grid.Column width={4}></Grid.Column>
                <Grid.Column width={4}>Action</Grid.Column>
                <Grid.Column width={3}>Did This Happen</Grid.Column>
              </Grid.Row>
            )  
          } 
          return (
            <Grid.Row verticalAlign="middle" color='grey'>
              <Grid.Column width={5}>Description</Grid.Column>
              <Grid.Column width={4}>Current Amount<br/>Current Match</Grid.Column>
              <Grid.Column width={4}>New Amount<br/>New Match</Grid.Column>
              <Grid.Column width={3}>Will This Happen</Grid.Column>
            </Grid.Row>
          ) 
      default:
        return (
          <Grid.Row verticalAlign="middle" color='grey'>
            <Grid.Column width={5}>Description</Grid.Column>
            <Grid.Column width={4}>Currently</Grid.Column>
            <Grid.Column width={4}>New Amount</Grid.Column>
            <Grid.Column width={3}>Will This Happen</Grid.Column>
          </Grid.Row>
        ) 
    }
  }
  render() {
    const { events, type } = this.props
    if (!events) return null
    const allowNext = true //!events.some((event)=>{return event.process===-1})

    let eventsStart
    let eventsEnd
    if (type==='property' || type==='debt'){
      eventsStart = events.filter((event)=>{return event.action==='start'})
      eventsEnd = events.filter((event)=>{return event.action!=='start'})
    } else if (type==='saving'){
      eventsStart = events.filter((event)=>{return event.action!=='convert'})
      eventsEnd = events.filter((event)=>{return event.action==='convert'})
    } else {
      eventsStart = events
    }
    
    return (
      <div className="ui container rollgrid">
        <Segment>
          <Form className='rollover_form'>
            <div style={{display: 'flex'}}>
            <img id='stepLogo' src={logo} alt='logo'/>
            <h1 className='center green'>Planned { this.renderType(type)} Changes</h1> 
            </div>
            <Grid style={{marginTop: '25px'}}>
            { !!eventsStart && (eventsStart.length > 0) && this.renderHeader(type, 'start') }
            { !!eventsStart && eventsStart.map((event,i) => {
                switch (event.type) {
                  case 'property':
                    return <RolloverRowProperty event={event} setYes={this.setYes} setNo={this.setNo} /* onDelete={this.onDelete} */ onChange={this.onChange} altRow={i % 2} />
                  case 'debt':
                    return <RolloverRowDebt event={event} setYes={this.setYes} setNo={this.setNo} /* onDelete={this.onDelete} */ onChange={this.onChange} altRow={i % 2} />
                  default:
                    return <RolloverRowOther event={event} setYes={this.setYes} setNo={this.setNo} /* onDelete={this.onDelete} */ onChange={this.onChange} altRow={i % 2} />
                }
              })  
            }
            { !!eventsEnd && (eventsEnd.length > 0) && this.renderHeader(type, 'end') }
            { !!eventsEnd && eventsEnd.map((event,i) => {
                switch (event.type) {
                  case 'property':
                    return <RolloverRowProperty event={event} setYes={this.setYes} setNo={this.setNo} /* onDelete={this.onDelete} */ onChange={this.onChange} altRow={i % 2}/>
                  case 'debt':
                    return <RolloverRowDebt event={event} setYes={this.setYes} setNo={this.setNo} /* onDelete={this.onDelete} */ onChange={this.onChange} altRow={i % 2} />
                  default:
                    return <RolloverRowOther event={event} setYes={this.setYes} setNo={this.setNo} /* onDelete={this.onDelete} */ onChange={this.onChange} altRow={i % 2} />
                }
              })
            }
            </Grid>          
            <div className='buttons' style={{height: '50px', marginTop: '25px'}}> 
              <Modal trigger={<Button content='Instructions'/>} header='Instructions' content={<div style={{margin: '25px'}}><div className='rollInstr'>For each event that has moved into this year we will ask you:</div>
                <div className='rollInstr'>Did or Will the event still happen?</div>
                <div className='rollInstr'>
                  <Button.Group style={{marginRight: '5px'}}>
                    <Button positive={true}>Yes</Button>
                    <Button.Or />
                    <Button>No</Button>
                    <Button.Or />
                    <Button>Undecided</Button>
                  </Button.Group> if the event did or will still happen, you can modify the amount here.
                </div>
                <div className='rollInstr'>
                  <Button.Group style={{marginRight: '5px'}}>
                    <Button >Yes</Button>
                    <Button.Or />
                    <Button negative={true}>No</Button>
                    <Button.Or />
                    <Button>Undecided</Button>
                  </Button.Group> if the event did not or will not happen this year.
                </div>
                <div className='rollInstr'>
                  <Button.Group style={{marginRight: '5px'}}>
                    <Button >Yes</Button>
                    <Button.Or />
                    <Button>No</Button>
                    <Button.Or />
                    <Button color='orange'>Undecided</Button>
                  </Button.Group> if you are not sure of your plans for this change. 
                </div>
                </div>} actions={['Close']}
              />
              <Button className='button_green' disabled={!allowNext} floated='right' content={ this.props.pos < this.props.last ? 'Next' : 'Finish'} onClick={this.props.onNext}/>
              { this.props.pos>0 && <Button color='orange' floated='right' content="Prev" onClick={this.props.onPrev}/>} 
            </div>
          </Form>
        </Segment>
      </div>
    )
  }
}

export default RolloverEvents